import { useEsaInfoMutation } from '../../../api';
import styles from './styles.module.scss';
import { VehicleEsaModel } from 'api-new/generated';
import { useAuth } from 'features/auth/contexts/auth';
import { FC, useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { ButtonWithIcon } from 'shared';
import { formatDate } from 'utils/formats';

type Props = {
  regNo?: string | null;
};

export const VauxhallVehicleHistoryPDFSection: FC<Props> = ({ regNo }) => {
  const { mutate, isLoading } = useEsaInfoMutation();
  const { currentUser } = useAuth();
  const [esaInfo, setEsaInfo] = useState<VehicleEsaModel | null>(null);

  const updateEsaInfo = (isForced: boolean) => {
    if (!currentUser || !regNo) return;

    mutate(
      {
        regNo: regNo,
        userId: currentUser.userId,
        isForced: isForced
      },
      {
        onSuccess: (data) => {
          setEsaInfo(data);
        }
      }
    );
  };

  useEffect(() => {
    updateEsaInfo(false);
  }, [regNo]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>Vauxhall Vehicle History PDF</div>
      {!esaInfo && (
        <div className={styles.emptyContainer}>
          <div className={styles.emptyTitle}>Vauxhall Vehicle History PDF not found</div>
          <div>
            <ButtonWithIcon
              iconPath="/media/icons/custom/zoom_1.svg"
              onClick={() => updateEsaInfo(true)}
              isLoading={isLoading}
            >
              Look Up Vauxhall Vehicle History PDF
            </ButtonWithIcon>
          </div>
        </div>
      )}

      {esaInfo && (
        <div>
          <div className={styles.createdInfo}>
            <div>
              Last Look Up - {esaInfo.date ? formatDate(esaInfo.date) : '-'} by {esaInfo.user ?? '-'}
            </div>
            <ButtonWithIcon
              iconPath="/media/icons/custom/zoom_1.svg"
              btnStyle="light-primary"
              onClick={() => updateEsaInfo(true)}
              isLoading={isLoading}
            >
              Update
            </ButtonWithIcon>
          </div>

          <div className={styles.scrollContainer} style={{ marginTop: '20px' }}>
            {esaInfo.htmlTable && <div dangerouslySetInnerHTML={{ __html: esaInfo.htmlTable }} />}
          </div>
        </div>
      )}

      {isLoading && (
        <div className={styles.skeletonContainer}>
          <Skeleton height={30} count={5} style={{ marginBottom: 10 }} />
        </div>
      )}
    </div>
  );
};
